import { render, staticRenderFns } from "./partnerWise.vue?vue&type=template&id=1bdfe5bc&scoped=true"
import script from "./partnerWise.vue?vue&type=script&lang=js"
export * from "./partnerWise.vue?vue&type=script&lang=js"
import style0 from "./partnerWise.vue?vue&type=style&index=0&id=1bdfe5bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bdfe5bc",
  null
  
)

export default component.exports